import React from 'react'
import ErrorMessage from '../../../UI/messages/ErrorMessage'
import { useState } from 'react'
import { useEffect } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../helpers/form/FormHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../helpers/form/FormData'
import SupplierNameField from './fields/SupplierNameField'
import SupplierEdrpouField from './fields/SupplierEdrpouField'
import MyButton from '../../../UI/form/MyButton'
import SupplierTypeSelect from './fields/SupplierTypeSelect'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { addSupplierAPI, editSupplierAPI } from '../../../../api/supply/supplierAPI'
import { useDispatch } from 'react-redux'
import { addSupplier } from '../../../../store/supplierSlice'

const SuppliersForm = ({ supplierBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(supplierBd ? supplierBd : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()

        // console.log('dataForBd', dataForBd)

        setError('')
        setLoading(true)

        if (dataForBd.id) {
            edit(dataForBd)
        } else {
            add(dataForBd)
        }
    }

    const add = (dataForBd) => {
        addSupplierAPI(dataForBd).then(data => {
            dispatch(addSupplier(data))
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const edit = (dataForBd) => {
        editSupplierAPI(dataForBd).then(data => {
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const setDataForBd = () => {
        let dataForBd = {
            type: data.type,
            name: data.name,
            edrpou: data.edrpou,
        }

        if (data.id) {
            dataForBd = {
                ...dataForBd,
                id: data.id
            }
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('type', 'supplier') ?
				<SupplierTypeSelect
					required={formDataProductRequiredField('type', 'supplier')}
					setValidate={e => updateValidate(setValid, 'type', e)}
					setValueForm={e => setValueForm(setData, 'type', e)}
					forciblyValue={data && data.type ? data.type : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('name', 'supplier') ?
				<SupplierNameField
					required={formDataProductRequiredField('name', 'supplier')}
					setValidate={e => updateValidate(setValid, 'name', e)}
					setValueForm={e => setValueForm(setData, 'name', e)}
					forciblyValue={data && data.name ? data.name : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('edrpou', 'supplier') ?
				<SupplierEdrpouField
					required={formDataProductRequiredField('edrpou', 'supplier')}
					setValidate={e => updateValidate(setValid, 'edrpou', e)}
					setValueForm={e => setValueForm(setData, 'edrpou', e)}
					forciblyValue={data && data.edrpou ? data.edrpou : ''}
				/>
			: ''
        }

        <ErrorMessage 
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default SuppliersForm